import User from "@views/user/User";

export default [
  {
    path: "/user",
    name: "User",
    meta: {
      title: "个人中心",
      keepAlive: true,
      footer: true,
      auth: true
    },
    component: User
  },
  {
    path: "/user/binding",
    name: "BindingPhone",
    meta: {
      title: "绑定手机",
      keepAlive: true,
      backgroundColor: "#fff",
      auth: true
    },
    component: () => import("@views/user/BindingPhone.vue")
  },
  {
    path: "/user/add_address/:id?",
    name: "AddAddress",
    meta: {
      title: "添加收货地址",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddAddress.vue")
  },
  {
    path: "/user/account",
    name: "UserAccount",
    meta: {
      title: "我的账户",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserAccount.vue")
  },
  {
    path: "/user/add_manage",
    name: "AddressManagement",
    meta: {
      title: "地址管理",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/address/AddressManagement.vue")
  },
  {
    path: "/user/poster",
    name: "Poster",
    meta: {
      title: "分销海报",
      keepAlive: false,
      backgroundColor: "#a3a3a3",
      auth: true
    },
    component: () => import("@views/user/promotion/Poster.vue")
  },
  {
    path: "/user/user_form",
    name: "Userform",
    meta: {
      title: "代理申请",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/Userform.vue")
  },
  {
    path: "/user/sign",
    name: "Sign",
    meta: {
      title: "签到",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/signIn/Sign.vue")
  },
  {
    path: "/user/sign_record",
    name: "SignRecord",
    meta: {
      title: "签到记录",
      keepAlive: true
    },
    component: () => import("@views/user/signIn/SignRecord.vue")
  },
  {
    path: "/user/cash",
    name: "UserCash",
    meta: {
      title: "提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/user/audit",
    name: "CashAudit",
    meta: {
      title: "提现审核",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashAudit.vue")
  },
  {
    path: "/user/promoter_order",
    name: "PromoterOrder",
    meta: {
      title: "佣金订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOrder.vue")
  },
  {
    path: "/user/promoter_list",
    name: "PromoterList",
    meta: {
      title: "推广人列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterList.vue")
  },
  {
    path: "/user/user_promotion",
    name: "UserPromotion",
    meta: {
      title: "我的推广",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserPromotion.vue")
  },
  {
    path: "/user/bill/:types?",
    name: "UserBill",
    meta: {
      title: "账单明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserBill.vue")
  },
  {
    path: "/user/yueRecord",
    name: "yueRecord",
    meta: {
      title: "余额记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/yueRecord.vue")}
    ,
  {
    path: "/user/cashrecord",
    name: "CashRecord",
    meta: {
      title: "提现记录",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CashRecord.vue")}
    ,
    {
      path: "/integralOrder/list/:type?",
      name: "integralOrderList",
      meta: {
        title: "积分订单",
        keepAlive: true,
        auth: true
      },
    component: () => import("@views/user/integral/IntegralOrder.vue")
  },
  {
    path: "/user/commission",
    name: "CommissionDetails",
    meta: {
      title: "佣金明细",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionDetails.vue")
  },
  {
    path: "/user/integral",
    name: "IntegralShow",
    meta: {
      title: "积分详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/Integral.vue")
  },
  {
    path: "/user/integralShop",
    name: "Integral",
    meta: {
      title: "积分商城",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/IntegralShop.vue")
  },
  {
    path: "/integralGoodCon/:id",
    name: "integralGoodCon",
    meta: {
      title: "商品详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/IntegralGoodCon.vue")
  }, 
  {
    path: "/user/vip",
    name: "UserVip",
    meta: {
      title: "会员中心",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/UserVip.vue")
  },
  {
    path: "/user/data",
    name: "PersonalData",
    meta: {
      title: "个人资料",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/PersonalData.vue")
  },
  {
    path: "/user/user_coupon",
    name: "UserCoupon",
    meta: {
      title: "我的优惠券",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/coupon/UserCoupon.vue")
  },
  {
    path: "/user/get_coupon",
    name: "GetCoupon",
    meta: {
      title: "领取优惠券",
      keepAlive: true
    },
    component: () => import("@views/user/coupon/GetCoupon.vue")
  },
  {
    path: "/user/user_cash",
    name: "UserCash",
    meta: {
      title: "申请提现",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/UserCash.vue")
  },
  {
    path: "/customer/list/:productId?",
    name: "CustomerList",
    meta: {
      title: "客服列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/CustomerList.vue")
  },
  {
    path: "/user/Recharge",
    name: "Recharge",
    meta: {
      title: "余额充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/Recharge.vue")
  },
  {
    path: "/user/promoter_rank",
    name: "PromoterRank",
    meta: {
      title: "推广人排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterRank.vue")
  },
  {
    path: "/user/commission/rank",
    name: "CommissionRank",
    meta: {
      title: "佣金排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CommissionRank.vue")
  },
  {
    path: "/user/promoter_offlinecommission",
    name: "PromoterOfflineCommission",
    meta: {
      title: "线下佣金",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterOfflineCommission.vue")
  },
  {
    path: "/user/integralGoodList",
    name: "integralGoodList",
    meta: {
      title: "积分产品搜索",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/IntegralGoodList.vue")
  },
  {
    path: "/integralOrder/logistics/:id",
    name: "Logistics",
    meta: {
      title: "积分订单物流信息",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/integral/Logistics.vue")
  },
  {
    path: "/user/promotion/agent_apply/city",
    name: "NewCityAgentForm",
    meta: {
      title: "代理申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/NewCityAgentForm.vue")
  },
  {
    path: "/user/promotion/agent_apply/:type",
    name: "CityAgentForm",
    meta: {
      title: "代理申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/CityAgentForm.vue")
  },
  // 24-06-05 分销申请
  {
    path: "/user/promotion/distribution_apply/index",
    name: "DistributionApply",
    meta: {
      title: "分销申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/DistributionApply.vue")
  },
  //10.20新加代理续费页面
  {
    path: "/user/promotion/agency_renewal/city_renew",
    name: "AgencyRenewal",
    meta: {
      title: "代理续费",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/AgencyRenewal.vue")
  },
  {
    path: "/user/promotion/discount_apply",
    name: "DiscountApplyForm",
    meta: {
      title: "特惠申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/DiscountApplyForm.vue")
  },
  {
    path: "/user/promotion/discount_apply",
    name: "DiscountApplyForm",
    meta: {
      title: "特惠申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/DiscountApplyForm.vue")
  },
  {
    path: "/user/promotion/agent_application_list",
    name: "AgentApplicationList",
    meta: {
      title: "代理申请列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/AgentApplicationList.vue")
  },
  {
    path: "/user/promotion/agent_application_detail/:id?",
    name: "AgentApplicationDetail",
    meta: {
      title: "代理申请详情",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/AgentApplicationDetail.vue")
  },
  // 20230407 吹风机置换
  {
    path: "/user/displace/apply",
    name: "DisplaceApply",
    meta: {
      title: "置换申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/displace/Apply.vue")
  },
  // 202300428 进货货申请
    {
      path: "/user/purchase/application",
      name: "DisplaceApply",
      meta: {
        title: "进货申请",
        // keepAlive: true,
        // auth: true
      },
      component: () => import("@views/user/purchase/Application.vue")
    },
  {
    path: "/user/promotion/promoter_applylist",
    name: "PromoterApplyList",
    meta: {
      title: "分销申请列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/PromoterApplyList.vue")
  },

  // 新增不焦虑版分销员
  {
    path: "/user/promotion/gold_promoter_applylist",
    name: "PromoterApplyList",
    meta: {
      title: "不焦虑版分销申请列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/GoldPromoterApplyList.vue")
  },
  {
    path: "/maintain",
    name: "maintain",
    meta: {
      title: "系统维护中",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/maintain.vue")
  },
  {
    path: "/user/scancode/rank",
    name: "ScanCodeRank",
    meta: {
      title: "代理推广排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/ScanCodeRank.vue")
  },
  {
    path: "/user/sales_volume/rank",
    name: "SalesVolumeRank",
    meta: {
      title: "代理销量排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/SalesVolumeRank.vue")
  },
  {
    path: "/user/salesamount_rank",
    name: "SalesAmountRank",
    meta: {
      title: "代理收益排行",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/promotion/SalesAmountRank.vue")
  },
     {
    path: "/user/ProxyRecharge",
    name: "ProxyRecharge",
    meta: {
      title: "代理充值",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/ProxyRecharge.vue")
  },
  {
    path: "/user/study_apply",
    name: "studyApply",
    meta: {
      title: "学习资格申请",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/user/studyApply.vue")
  },
   {
    path: "/user/user_form",
    name: "Userform",
    meta: {
      title: "代理申请",
      keepAlive: false,
      auth: true
    },
    component: () => import("@views/user/promotion/Userform.vue")
  },
];
